import { useAnnounce } from "@src/components/live-announcer";
import { NO_INTERPOLATION_ESCAPE } from "@src/raya-lucaria/i18n/interpolation";
import { focusMain } from "@src/utils/focus-main";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

let lastAnnouncedOrganizationCode = "";

export function forgetLastAnnouncedOrganization() {
  lastAnnouncedOrganizationCode = "";
}

export function useAnnounceOrganizationSwitch(
  organizationCode: string,
  organizationName: string | undefined,
  inaccessible: boolean,
) {
  const { t } = useTranslation();
  const announce = useAnnounce();

  useEffect(() => {
    if (!organizationCode) return;
    if (inaccessible) {
      lastAnnouncedOrganizationCode = "";
      return;
    }
    if (!organizationName) return;
    if (lastAnnouncedOrganizationCode === organizationCode) return;
    const previousOrganizationCode = lastAnnouncedOrganizationCode;
    lastAnnouncedOrganizationCode = organizationCode;
    if (previousOrganizationCode) {
      announce(
        t("switchedToOrganization", {
          organization: organizationName,
          interpolation: NO_INTERPOLATION_ESCAPE,
        }),
      );
      if (document.activeElement === document.body) focusMain();
    }
  }, [announce, inaccessible, organizationCode, organizationName, t]);
}
